import React, { useEffect, useRef } from "react";
import styled from "styled-components";

import { Card } from "../main/component/Card";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { findTest, getRelatedTests } from "../../data/data";
import DisplayAds from "../../components/DisplayAdsFlex";
import { MOODS } from "../../story/effects";
import { tx } from "../../story/texts";

export const TestMain = () => {
  const navigate = useNavigate();
  const ref = useRef(null);
  const { id } = useParams();
  const data = findTest(id);

  // 다른 테스트로 이동하면 맨 위로
  useEffect(() => {
    window.scrollTo(0, 0);
    if (ref.current) {
      ref.current.scrollTo({ top: 0 });
    }
  }, [id]);

  if (!data) return <Navigate to="/" replace />;

  const relatedTests = getRelatedTests(data);

  return (
    <Wrapper ref={ref}>
      <Container>
        <pre
          style={{
            fontFamily: "GyeonggiBatang",
            fontSize: 25,
            marginTop: 36,
          }}
        >
          {data.title}
        </pre>
        <br />
        <div
          style={{
            fontFamily: "GyeonggiBatang",
            fontSize: 18,
            fontWeight: 400,
            color: "gray",
          }}
        >
          {data.subTitle}
        </div>
        {data.thumbnail ? (
          <Thumbnail src={data.thumbnail} alt={data.title} />
        ) : (
          <StoryCover aria-hidden="true">
            <span>🎧</span>
            {tx(data, "introHint")}
          </StoryCover>
        )}

        <DisplayAds />
        <br />

        <InfoContainer>
          <pre
            style={{
              fontFamily: "GyeonggiBatang",
              textAlign: "start",
              fontSize: 15.5,
              fontWeight: 400,
            }}
          >
            {data.description}
          </pre>
        </InfoContainer>
        <StartBtn
          type="button"
          onClick={() => {
            navigate(`/test-main/${data.id}/test`);
          }}
        >
          {data.kind === "story" ? tx(data, "startButton") : "시작하기"}
        </StartBtn>
      </Container>
      <TestList>
        {relatedTests.map((item, index) => (
          <FlexColumn key={item.id}>
            {index % 3 === 0 && <DisplayAds />}
            <Card cardItem={item} />
          </FlexColumn>
        ))}
        {relatedTests.length === 0 && <DisplayAds />}
      </TestList>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 1px;
  overflow: scroll;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const Thumbnail = styled.img`
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
  object-position: center;
  margin: 24px 0px;
  border-radius: 15px; /* 모서리 둥근 정도 */
`;

const StoryCover = styled.div`
  width: 100%;
  aspect-ratio: 1/1;
  margin: 24px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  font-size: 16px;
  color: #f1ece4;
  background: ${MOODS.밤};

  span {
    font-size: 40px;
  }
`;

const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  line-height: 1.35;
`;

const StartBtn = styled.button`
  width: 222px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  border-radius: 30px;
  border: 0;

  background-color: #133337;

  margin: 0 auto;
  margin-top: 36px;

  font-family: "GyeonggiBatang";
  font-size: 17.5px;
  font-weight: 400;
  color: white;

  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  transition: all 0.2s ease;

  &:hover {
    background-color: #130a3e;
  }
`;

const TestList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  margin-top: 48px;
  padding-bottom: 24px;
`;

const FlexColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;